import React, { memo } from 'react';
import SectionDetailSingleton from './SectionDetailSingleton';
import SectionFormSingleton from './SectionFormSingleton';

const SectionPanel = memo(({ 
  selectedItem, 
  showForm, 
  handleUnselectItem, 
  handleEditItem, 
  handleDeleteItem, 
  handleDeleteConfirmation,
  handleSectionAdd,
  setShowForm 
}) => {
  console.log('SectionPanel rendered with selectedItem:', selectedItem, 'showForm:', showForm);
  
  if (showForm) {
    return (
      <SectionFormSingleton
        editingItem={selectedItem}
        closeForm={() => {
          setShowForm(false);
          handleUnselectItem();
        }}
        onSectionAdd={handleSectionAdd}
      />
    );
  }

  return (
    <SectionDetailSingleton
      selectedItem={selectedItem}
      handleUnselectItem={handleUnselectItem}
      handleEditItem={() => setShowForm(true)}
      handleDeleteItem={() => handleDeleteConfirmation(selectedItem)}
    />
  );
});

SectionPanel.displayName = 'SectionPanel';

export default SectionPanel;
